import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import UserCompetenceCard from './userCompetenceCard';

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gridGap: 8,
  },
}));

const MatchedUsersList = ({
  className = undefined,
  matchedUsers,
  isUserProfileAccessible,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      {matchedUsers.map(matchedUser => (
        <UserCompetenceCard
          key={`matched_user_${matchedUser.user.id}`}
          matchedUser={matchedUser}
          isUserProfileAccessible={isUserProfileAccessible}
        />
      ))}
    </div>
  );
};


MatchedUsersList.propTypes = {
  className: PropTypes.string,
  matchedUsers: PropTypes.arrayOf(PropTypes.object).isRequired,
  isUserProfileAccessible: PropTypes.func.isRequired,
};

export default MatchedUsersList;
